import { render, staticRenderFns } from "./product-box.vue?vue&type=template&id=427125f0&scoped=true&"
import script from "./product-box.vue?vue&type=script&lang=js&"
export * from "./product-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427125f0",
  null
  
)

export default component.exports